/**
 * @desc 请求报告返回分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.requestResultPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/requestResultPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
